const SouscriptionCustomerExtraFormCfeRepresentative = () => null;

export default SouscriptionCustomerExtraFormCfeRepresentative;
